import { Head } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import { PlayerDetailPage } from '@/components/screens/PlayerDetailScreen'

/* The Inertia boundary. The screen below still reads from @/fixtures; when a
 * controller starts handing this page real props they get passed through here,
 * and the screen stops importing fixtures at all. */
export default function PlayerDetailShow({ playerId }: { playerId: string }) {
  return (
    <AppLayout>
      <Head title="Player" />
      <PlayerDetailPage playerId={playerId} />
    </AppLayout>
  )
}
